import { Component, inject } from '@angular/core';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CDS_POPUP_DATA, MatDialogRef, CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';
@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  imports: [CdsPopupModule, CdsButtonModule, CdsLanguageModule],
})
export class ConfirmPopupComponent {
  private dialogRef = inject<MatDialogRef<ConfirmPopupComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    message: string;
  }>(CDS_POPUP_DATA);

  disagreeButtonConfig: CdsButtonConfig = { size: 'sm', style: 'secondary' };
  agreeButtonConfig: CdsButtonConfig = { size: 'sm' };
  agree() {
    this.dialogRef.close({ agree: true });
  }
  close() {
    this.dialogRef.close({ agree: false });
  }
}
